import React, { useState } from "react";
import { FaUser,FaLock } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import '../LoginPageCss.css'
import Image from '../assets/Logo.jpeg';
import { loginAction, registerAction } from "../redux/actions/auth";
import {useDispatch} from 'react-redux';

import useToken from "../hooks/useToken";
import { Navigate } from "react-router-dom";

const Auth = () => {

const [signUp,setSignUp] = useState(false);
const [authData,setAuthData] = useState({username:"",email:"",password:""});
const dispatch = useDispatch();
const [token] = useToken();

 const onChangeFunc = (e) =>{
  setAuthData({...authData,[e.target.name] : e.target.value})
}

const authFunc = ()=>{
      if (signUp) {
             dispatch(registerAction(authData))
      }else{
            dispatch(loginAction(authData))
      }
}
if (token?.token) {
      return <Navigate to="/" replace />;
    }
  

console.log(authData,"autdata");


  return (
    <> 
     <div className="auth-container">
       <div className=" wrapper ">

 
      <div style={{textAlign:'center'}}>
      {/* <h1 style={{fontFamily:'dancing Script',color:'#b7b7b7'}}>Yükselirken Çözüm Ortağınız</h1> */}
      <img src={Image} alt="Yükselirken Çözüm Ortağınız" style={{width: '75%', height: 'auto', maxWidth: '600px'}} />
                </div>
      {signUp &&
      <div className="input-box">
            <input type="text" placeholder="Kullanıcı Adı" value={authData.username} onChange={onChangeFunc} name="username" required></input><FaUser className="icon" />
      </div>
       }  
      <div className="input-box">
            <input type="text" placeholder="E-mail" value={authData.email} onChange={onChangeFunc} name="email" required></input><IoMdMail className="icon" />
      </div>
      <div className="input-box" >
            <input type="password" placeholder="Şifre" value={authData.password} onChange={onChangeFunc} name="password" required></input><FaLock className="icon"/>
      </div>
{signUp ? <button onClick={authFunc}  type="submit">Kayıt Ol</button>:
 <button onClick={authFunc}  type="submit">Giriş Yap</button>
  }
    

      <div style={{marginTop:'4%',cursor:'pointer',marginLeft:'50%',fontSize:'14px'}}>
        {signUp?
              <span onClick={()=>setSignUp(false)}> Zaten Üyeyseniz Tıklayınız</span>
              :
              <span onClick={()=>setSignUp(true)}> Yeni Kayıt İçin Tıklayınız</span>
      }
    
      </div>

    </div>
    </div>
    </>

  );
};

export default Auth;
